export const useTemplatePreviewDimensions = ({ width, height }: { width: number; height: number }) => {
  const aspectRatio = width / height
  let rows = 2
  let columns = 3

  // ie: youtube channel art
  if (width > height) {
    columns = 3
  }

  // ie: instagram landscape post
  if (aspectRatio > 1.8) {
    columns = 2
  }

  // ie: facebook cover
  if (aspectRatio > 2.5) {
    columns = 2
    rows = 1
  }

  // ie: ig story
  if (aspectRatio < 0.75) {
    columns = 5
  }

  return {
    aspectRatio,
    rows,
    columns,
  }
}
